import { render, staticRenderFns } from "./SongShow.vue?vue&type=template&id=4d6cdd9d"
import script from "./SongShow.vue?vue&type=script&lang=js"
export * from "./SongShow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports